import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { WelcomeMessage } from '@/models'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize from 'rehype-sanitize'
import rehypeKatex from 'rehype-katex'

export function WelcomeMessageCard(welcomeMessage: WelcomeMessage) {
    return (
        <Card className="min-w-80 max-w-[30rem]">
            <CardHeader>
                <CardTitle>{welcomeMessage.title}</CardTitle>
                {welcomeMessage.subtitle && <CardDescription>{welcomeMessage.subtitle}</CardDescription>}
            </CardHeader>
            <CardContent className="">
                <ReactMarkdown
                    remarkPlugins={[remarkGfm, remarkMath]}
                    rehypePlugins={[rehypeRaw, rehypeSanitize, rehypeKatex]}
                    components={{
                        a: ({ ...props }) => (
                            <a {...props} target="_blank" rel="noreferrer" className="text-primary underline" />
                        ),
                    }}
                >
                    {welcomeMessage.content}
                </ReactMarkdown>
            </CardContent>
        </Card>
    )
}
